import AutoDeliveryAsapPage from '@/containers/AutoDeliveryPage/AutoDeliveryAsapPage';
import autoDeliveryDcxService from '@/services/autoDeliveryDcxService';
import appRouterService from '@/services/route/appRouterService';

const AutoDeliveryAsapPageSwitcher = (props) => {
    const isDcx = autoDeliveryDcxService.getIsAutoDeliveryDcxEnabled();

    if (isDcx) {
        // DCX has no dedicated ASAP page, so redirect to the standard Auto Delivery page instead.
        appRouterService.forwardToAutoDeliveryPage();
        return null;
    }

    return <AutoDeliveryAsapPage {...props} />;
};

export default AutoDeliveryAsapPageSwitcher;
